import { ChangeEmailConfirm } from '@app/auth/components/ChangeEmailConfirm';

export const ChangeEmailConfirmPage = () => {
  return <ChangeEmailConfirm />;
};
